"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_router_config_1 = require("react-router-config");
const translation_1 = require("../../../common/js/helper/translation");
const TabsNavigation_1 = __importDefault(require("../TabsNavigation"));
class UserProfilePage extends react_1.default.Component {
    componentDidMount() {
        document.title = (0, translation_1.t)('user_subpage_title', { title: (0, translation_1.t)('user.profile.page_title') });
    }
    render() {
        return (react_1.default.createElement("section", { className: "znd-user-profile-page" },
            react_1.default.createElement("div", { className: "znd-top-page" },
                react_1.default.createElement("h1", { className: "znd-top-page__title t-headline-2" }, (0, translation_1.t)('user.profile.title'))),
            react_1.default.createElement(TabsNavigation_1.default, { className: "znd-tabs__category-navigation znd-user-profile-page__sticky-header", routes: this.props.route?.routes ?? [] }),
            (0, react_router_config_1.renderRoutes)(this.props.route?.routes)));
    }
}
exports.default = (0, react_i18next_1.withTranslation)()((0, mobx_react_1.observer)(UserProfilePage));
